import Loader from '../components/common/loader/Loader';
import { useInspectorAuth } from '../hooks/use-inspector-auth';
import type { ReactElement } from 'react';
import { Redirect, Route } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';
import PATH_ROUTES from '../static/constants/path-routes';

type InspectorRouteGuardProps = Required<Pick<RouteProps, 'component'>> &
  Omit<RouteProps, 'component'>;

export function InspectorRouteGuard({
  component: Component,
  ...rest
}: InspectorRouteGuardProps): ReactElement {
  const { isAuthenticated, isLoading } = useInspectorAuth();

  if (isLoading) {
    return <Loader isActive={isLoading} />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: PATH_ROUTES.INSPECTOR_FORM_NOT_AUTHORIZED,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
